<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
      <el-form-item label="城市公司" prop="cityIds" class="width100">
        <el-select v-model="form.cityIds" placeholder="请选择城市公司" filterable size="small" clearable>
          <el-option v-for="item in cityCompanyOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="账套配置" class="width100" style="font-weight: 600"></el-form-item> -->
      <el-form-item label="机构ID" prop="idMarketingOrgan" class="width100">
        <el-select v-model="form.idMarketingOrgan" placeholder="请选择机构" filterable size="small" clearable>
          <el-option
            v-for="item in marketingOrganOptions"
            :key="item.ID"
            :label="item.Name"
            :value="`${item.ID}-${item.Code}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否是旧系统账套" prop="isUseOrder" class="width100">
        <el-radio-group v-model="form.isUseOrder">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否教育公司用于收学费" prop="isUseEducation" class="width100">
        <el-radio-group v-model="form.isUseEducation">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import yongyouConfigApi from '@/api/config/yongyouConfig'

function initFormBean() {
  const formBean = {
    cityIds: null,
    idMarketingOrgan: null,
    isUseEducation: 0,
    state: 0,
    isUseOrder: 0,
  }
  return formBean
}

export default {
  props: ['cityCompanyOptions', 'marketingOrganOptions'],
  data() {
    return {
      old: initFormBean(),
      form: initFormBean(),
      formVisible: false,
      formRules: {
        cityIds: [{ required: true, message: '请选择城市公司', trigger: 'change' }],
        idMarketingOrgan: [{ required: true, message: '请选择机构', trigger: 'change' }],
        isUseOrder: [{ required: true, message: '请选择是否是旧系统账套', trigger: 'change' }],
        isUseEducation: [{ required: true, message: '请选择是否教育公司用于收学费', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
    }
  },
  created() {
    
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      for (const key in initFormBean()) {
        this.form[key] = this.old[key]
      }
    },
    /**
     * 打开新建表单
     */
    handleCreate(total) {
      this.old = initFormBean();
      this.form = initFormBean();
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 打开新建机构表单
     */
    handleCreatejigou(total) {
      this.old = initFormBean();
      this.form = initFormBean();
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.old = { ...row }
      this.resetForm()
      this.form.cityIds = +row.cityIds.replaceAll('#', '')
      this.form.id = row.id
      // 兼容旧数据：若仅存储了 ID，则根据下拉数据补全为 ID-Code 以便回显
      if (this.form.idMarketingOrgan && !String(this.form.idMarketingOrgan).includes('-')) {
        const found = this.marketingOrganOptions && this.marketingOrganOptions.find(o => String(o.ID) === String(this.form.idMarketingOrgan))
        if (found) {
          this.form.idMarketingOrgan = `${found.ID}-${found.Code}`
        }
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.cityIds = `#${params.cityIds}#`
      // 提交前兼容旧值：若为纯 ID，则按选项拼接为 ID-Code
      if (params.idMarketingOrgan && !String(params.idMarketingOrgan).includes('-')) {
        const found = this.marketingOrganOptions && this.marketingOrganOptions.find(o => String(o.ID) === String(params.idMarketingOrgan))
        if (found) {
          params.idMarketingOrgan = `${found.ID}-${found.Code}`
        }
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          yongyouConfigApi.addOrUpdateConfig(params).then((data) => {
            this.postCallback(data)
          });
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
